import { render, staticRenderFns } from "./AI.vue?vue&type=template&id=7ca813b0&scoped=true&"
import script from "./AI.vue?vue&type=script&lang=js&"
export * from "./AI.vue?vue&type=script&lang=js&"
import style0 from "./AI.vue?vue&type=style&index=0&id=7ca813b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca813b0",
  null
  
)

export default component.exports